import React from 'react';

import StarIcon from '../../../assets/star-icon';
import AngleRightIcon from '../../../assets/angle-right-icon';
import StarBorderIcon from '../../../assets/star-border-icon';
import useGet from '../../../hook/use-get';
import { API } from '../../../helpers/constants';
import { formattedDate } from '../../../helpers/formatted';
import { SectionError } from '../../../components/error';

const ReviewItem = ({ rating, name, date, message }) => {
  const StarRating = Array(5)
    .fill(null)
    .map((_, index) => {
      if (index <= rating - 1) return <StarIcon size={14} />;
      return <StarBorderIcon />;
    });

  return (
    <>
      <div className="">
        <div className="flex justify-between items-center">
          <h3 className="text-left text-sm font-bold">{name}</h3>
          <div className="flex gap-2">{StarRating.map((Item) => Item)}</div>
        </div>
        <h3 className="text-left text-[12px]">
          {formattedDate(date, {
            isShowDay: false
          })}
        </h3>
      </div>
      <p className="text-left text-sm">{message}</p>
    </>
  );
};

const RatingReview = ({ onClickMoreButtonBottom, id, rateAverage, totalRate, isShowAll }) => {
  const { data, isFetching, isError, refetch } = useGet({
    queryKey: 'rateReview',
    api: `${API.rate}/${id}`,
    options: {
      enabled: !!id
    }
  });

  const reviewData = isShowAll ? data : data?.slice(0, 3);

  if (isError) {
    return (
      <>
        <div className="flex flex-row gap-2">
          <h3 className="text-left text-xl font-bold">Ulasan</h3>
          <StarIcon size={24} />
        </div>
        <SectionError refetch={refetch} />
      </>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <h3 className="text-left text-xl font-bold">Ulasan</h3>
          <StarIcon size={24} />
          {isFetching ? (
            <>
              <div className="w-20 h-8 bg-gray-200 animate-pulse rounded" />
              <div className="w-20 h-8 bg-gray-200 animate-pulse rounded" />
            </>
          ) : (
            <>
              <h3 className="text-left text-xl font-bold">{rateAverage}</h3>
              <h3>({totalRate} Ulasan)</h3>
            </>
          )}
        </div>
      </div>
      <div className="space-y-3">
        {isFetching ? (
          <>
            <hr className="my-4" />
            <div className="w-full h-14 bg-gray-200 animate-pulse rounded" />
            <div className="w-full h-14 bg-gray-200 animate-pulse rounded" />
            <div className="w-full h-14 bg-gray-200 animate-pulse rounded" />
          </>
        ) : (
          reviewData?.map((item) => (
            <>
              <hr className="my-4" />
              <ReviewItem
                name={item?.name}
                rating={item?.ratting}
                date={item?.['created_at']}
                message={item?.review}
              />
            </>
          ))
        )}
        {onClickMoreButtonBottom && (
          <>
            <hr className="my-4" />
            <button
              disabled={isFetching}
              onClick={onClickMoreButtonBottom}
              className="inline-flex items-center gap-2 rounded-lg text-sm px-5 pt-3 focus:outline-none"
            >
              <span className={`text-primary-500 font-medium text-sm`}>Lihat Selengkapnya</span>
              <AngleRightIcon color={'#049B56'} />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default RatingReview;
